<div class="spinner-container" [class.full-screen]="fullScreen">
  <ngx-spinner [name]="spinnerName" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ffffff" type = "square-jelly-box" [fullScreen]="fullScreen">
    <!-- <p class="spinner-text">Loading...</p> -->
  </ngx-spinner>
</div>
